module.exports = __webpack_public_path__ + "static/media/undraw_mobile_development_8gyo.88556646.svg";